import { IonImg, IonModal } from '@ionic/react';
import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

export const CoinsPaywallModalStyles = styled(IonModal)<{
  staticTheme: 'dark-violet' | 'domination' | 'purple-gradient' | undefined;
}>`
  body.dark & {
    ion-content {
      --background: linear-gradient(
        360deg,
        #2b0e21 0%,
        #14111e 49.18%,
        #1e0f34 100%
      );

      ${({ staticTheme }) =>
        staticTheme === 'dark-violet' &&
        `
        --background: #43285B;
      `}
    }
  }

  --border-radius: 28px 28px 0 0;

  ion-content {
    --background: #fff;

    &::part(scroll) {
      padding: 16px;
    }
  }
`;

export const ImageStyles = styled.div`
  max-width: 375px;
  width: 100%;
  aspect-ratio: 375/272;
  margin: 0 auto 0;

  ion-img {
    width: 100%;
    height: 100%;
  }
`;

export const TitleStyles = styled(UiTypography)`
  margin-bottom: 12px;
  background: linear-gradient(89.79deg, #dac6ff 5.03%, #ffb3d1 94.68%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`;

export const SubtitleStyles = styled(UiTypography)`
  margin-bottom: 16px;
`;

export const BannerStyles = styled.div`
  max-width: 343px;
  width: 100%;
  aspect-ratio: 343/136;
  margin: 0 auto 20px;
  padding: 20px 32px;
  display: flex;
  align-items: center;
  gap: 24px;
  position: relative;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.05);
`;

export const BannerImageStyles = styled.img`
  max-width: 112px;
  width: 100%;
  aspect-ratio: 112/71;
`;

export const BannerContentStyles = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BannerContentPriceStyles = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const OneTimeOfferBadgeStyles = styled(UiTypography)`
  width: 105px;
  background: #fe1b74;
  color: white;
  border-radius: 4px;
  text-align: center;
  padding: 2px 0;
  margin-bottom: 4px;
`;

export const ActionButtonsStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
